/**
 * RaffleHeader - Header bar for raffle viewer page
 * Shows "OneChurch" branding centered, with back button for PWA/browser
 * In Telegram Mini App, the native BackButton is used instead
 */

import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { getAppContext } from "@/lib/telegram";
import styles from "./RaffleHeader.module.css";

export function RaffleHeader() {
  const navigate = useNavigate();
  const appContext = getAppContext();
  const showBackButton = appContext !== "miniapp";

  const handleBack = useCallback(() => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  }, [navigate]);

  return (
    <header className={styles.header}>
      {/* Left: Back button for PWA/browser, spacer for Mini App */}
      {showBackButton ? (
        <button
          onClick={handleBack}
          className={styles.backButton}
          aria-label="Назад"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={styles.backIcon}
          >
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
      ) : (
        <div className={styles.leftSpacer} aria-hidden />
      )}

      {/* Center: Brand name */}
      <div className={styles.centerContent}>
        <span className={styles.brandName}>
          <span className={styles.brandOne}>One</span>
          <span>Church</span>
        </span>
      </div>

      {/* Right spacer for balance */}
      <div className={styles.rightSpacer} aria-hidden />
    </header>
  );
}

export default RaffleHeader;
